// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__U_Vwm","header":"ReportDetails_header__3wVA6","title":"ReportDetails_title__Sqsym","left":"ReportDetails_left__1vHqb"};